/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_StaleInputs */

const en_directory_knowledge_stale = /** @type {(inputs: Directory_Knowledge_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs re-verification`)
};

const zh_directory_knowledge_stale = /** @type {(inputs: Directory_Knowledge_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要重新验证`)
};

/**
* | output |
* | --- |
* | "Needs re-verification" |
*
* @param {Directory_Knowledge_StaleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_stale = /** @type {((inputs?: Directory_Knowledge_StaleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_StaleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_stale(inputs)
	return zh_directory_knowledge_stale(inputs)
});
export { directory_knowledge_stale as "directory.knowledge.stale" }